import { createContext, useContext } from 'react';

const DeviceContext = createContext(undefined);

export function DeviceProvider({ value, children }) {
  return <DeviceContext.Provider value={value}>{children}</DeviceContext.Provider>;
}

export function useDeviceContext() {
  const ctx = useContext(DeviceContext);
  if (ctx === undefined) {
    throw new Error('useDeviceContext must be used within a DeviceProvider');
  }
  return ctx;
}
